import { NavLink } from 'react-router-dom';
import { LuLogOut, LuShieldCheck } from 'react-icons/lu';

function AdminSidebar({
  user,
  category,
  onCategoryChange,
  sidebarOpen,
  onClose,
  onLogout,
  moduleGroups,
  modules,
}) {
  return (
    <>
      {sidebarOpen && <button className="admin-sidebar-backdrop" aria-label="Close navigation" onClick={onClose} />}
      <aside className={`admin-sidebar${sidebarOpen ? ' is-open' : ''}`}>
        <NavLink className="admin-brand" to="/admin/dashboard" onClick={onClose}>
          <img src={`${process.env.PUBLIC_URL}/logow.png`} alt="AeroConveyor Logo" />
        </NavLink>
        <div className="admin-category-nav" role="group" aria-label="Airport data scope">
          {['Domestic', 'International'].map(item => (
            <button
              key={item}
              type="button"
              aria-pressed={category === item}
              className={category === item ? 'selected' : ''}
              onClick={() => {
                onCategoryChange(item);
                onClose();
              }}
            >
              {item}
            </button>
          ))}
        </div>
        <nav className="workspace-side-nav" aria-label="Admin modules">
          {moduleGroups.map(group => (
            <div className="workspace-nav-group" key={group}>
              <div className="admin-nav-label">{group.toUpperCase()}</div>
              {modules.filter(module => module.group === group).map(module => {
                const Icon = module.icon;
                return (
                  <NavLink
                    key={module.key}
                    to={`/admin/${module.key}`}
                    onClick={onClose}
                    end
                    className={({ isActive }) => `admin-nav-item${isActive ? ' active' : ''}`}
                  >
                    <Icon size={17} />
                    <span>{module.label}</span>
                  </NavLink>
                );
              })}
            </div>
          ))}
        </nav>
        <div className="admin-sidebar-bottom">
          {/* <div className="admin-help-card">
            <span className="admin-help-icon"><LuCircleHelp size={17} /></span>
            <strong>Airport operations</strong>
            <span>Monitor belt assets, baggage flow and maintenance from one workspace.</span>
          </div> */}
          <div className="admin-user">
            <NavLink className="admin-user-profile-link" to="/admin/profile" aria-label="Open administrator profile" onClick={onClose}>
              <span className="admin-user-avatar">{user?.name?.trim()?.split(/\s+/).slice(0, 2).map(part => part[0]).join('').toUpperCase() || 'AD'}</span>
              <span><strong>{user?.name || 'Administrator'}</strong><small>Admin account</small></span>
              <LuShieldCheck className="admin-user-shield" size={17} />
            </NavLink>
            <button className="admin-logout-button" type="button" aria-label="Log out" title="Log out" onClick={onLogout}><LuLogOut size={15} /></button>
          </div>
        </div>
      </aside>
    </>
  );
}

export default AdminSidebar;
